import { createContext, useContext, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * The topbar's action slot.
 *
 * The page title lives in the topbar (never repeated in the body), and a page's
 * primary actions — Add, Export, Customize, a period filter — belong up there
 * beside it, not in a second header row that eats vertical space. A page renders
 * them through `<PageActions>`, which portals into this slot in the topbar. The
 * value is the slot element (null until the topbar mounts it).
 */
export const PageActionsSlotContext = createContext<HTMLElement | null>(null)

/** Renders its children into the topbar's action slot (right of the title). */
export function PageActions({ children }: { children: ReactNode }) {
  const slot = useContext(PageActionsSlotContext)
  if (!slot) return null
  return createPortal(children, slot)
}
